import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { deepKeysToCamel } from '@eb/transformation-utils';
import { HAS_WINDOW } from '@eb/feature-detection';

import { setLanguage } from '@eb/i18n';

import {
    ENV_SHAPE_PROP_TYPE,
    REQUEST_SHAPE_PROP_TYPE,
    USER_SHAPE_PROP_TYPE,
    FOOTER_LINKS_SHAPE_PROP_TYPE,
} from '@eb/site-structure';

import { initRUM } from './services/datadogRUM';
import { previewReg } from './constants';

import Page from './pages/Page';
import ContentHub from './pages/ContentHub';

const getIsPreview = () => {
    const path = window?.location.pathname;
    return previewReg.test(path);
};

const isPreview = HAS_WINDOW && getIsPreview();

const DigitalContentApp = (props = {}) => {
    const { isAuthenticated = false, email = '', fullName = '' } = props.user;
    const { enableDigitalContentRUMTrial = false, launchZoomSDK = false } =
        props.featureFlags || {};
    const event = deepKeysToCamel(props.event);

    useEffect(() => {
        if (enableDigitalContentRUMTrial) {
            const app = { name: props.app_name, version: props.app_version };
            initRUM(app, props.user);
        }
    }, [
        enableDigitalContentRUMTrial,
        props.app_name,
        props.app_version,
        props.user,
    ]);

    setLanguage(props.env.localeInfo.locale);
    return (
        <Page {...props}>
            <ContentHub
                {...props}
                event={event}
                isPreview={isPreview}
                isUserAuthenticated={isAuthenticated}
                userEmail={email}
                userFullName={fullName}
                launchZoomSDK={launchZoomSDK}
            />
        </Page>
    );
};

DigitalContentApp.propTypes = {
    env: ENV_SHAPE_PROP_TYPE.isRequired,
    request: REQUEST_SHAPE_PROP_TYPE.isRequired,
    user: USER_SHAPE_PROP_TYPE.isRequired,
    footerLinks: FOOTER_LINKS_SHAPE_PROP_TYPE.isRequired,
    attendeeId: PropTypes.number,
    isAttendee: PropTypes.bool,
    hasPermission: PropTypes.bool,
    ticketClasses: PropTypes.array,
};

export default DigitalContentApp;
